import AccountIcon from "./src/account.svg";
import AdminReadConvosIcon from "./src/admin-read-convos.svg";
import AffirmLogoIcon from "./src/affirm-logo.png";
import AlreadyHasContractorIcon from "./src/already-has-contractor.svg";
import AvatarIcon from "./src/avatar.svg";
import BackyardIcon from "./src/backyard.svg";
import BellIcon from "./src/bell.svg";
import BipocOwnedIcon from "./src/bipoc-owned.svg";
import BlueprintIcon from "./src/blueprint.svg";
import BondedIcon from "./src/bonded.svg";
import BookingFastIcon from "./src/booking-fast.svg";
import BudgetIcon from "./src/budget.svg";
import BuildProjectIcon from "./src/build-projects.svg";
import CalendarMonthIcon from "./src/calendar-month.svg";
import CalendarIcon from "./src/calendar.svg";
import Chat2Icon from "./src/chat-2.svg";
import ChatIcon3 from "./src/chat-3.svg";
import ChatBubble from "./src/chat-bubble.svg";
import ChatOutlineIcon from "./src/chat-outline.svg";
import ChatIcon from "./src/chat.svg";
import Check1Icon from "./src/check-1.svg";
import ChecklistIcon from "./src/checklist.svg";
import CircledCheckIcon from "./src/circled-check.svg";
import ConstructorIcon from "./src/constructor.svg";
import ConversationIcon from "./src/conversation-1.svg";
import CopyIcon from "./src/copy-icon.svg";
import DesignProjectsIcon from "./src/design-projects.svg";
import DiyIcon from "./src/diy.svg";
import EcoFriendlyIcon from "./src/eco-friendly.svg";
import EstimateMatchIcon from "./src/estimateMatchGuarantee.svg";
import EstimatesIcon from "./src/estimates.svg";
import ExteriorHomeIcon from "./src/exterior-home.svg";
import FamilyOwnedIcon from "./src/family-owned.svg";
import FemaleFoundedIcon from "./src/female-founded.svg";
import FiltersIcon from "./src/filters.svg";
import FinishQuicklyIcon from "./src/finish-quickly.svg";
import FreeEstimatesIcon from "./src/free-estimates.svg";
import FrontYardIcon from "./src/front-yard.svg";
import FullYardIcon from "./src/full-yard.svg";
import GoodbyeIcon from "./src/goodbye.svg";
import GuidanceIcon from "./src/guidance.svg";
import HandShakeIcon from "./src/handshake.svg";
import HangingLightIcon from "./src/hanging-light.svg";
import HelmetOutlineIcon from "./src/helmet-outline.svg";
import HelmetIcon from "./src/helmet.svg";
import HelpCenterIcon from "./src/help-center.svg";
import HelpIcon from "./src/help.svg";
import HouseAndBushes from "./src/house-and-bushes.svg";
import LicensedIcon from "./src/licensed.svg";
import LoadingArrows from "./src/loading-arrows.svg";
import LocationMarkerIcon from "./src/location-marker.svg";
import LoginIcon from "./src/login.svg";
import LogoutIcon from "./src/logout.svg";
import MeasuementTapeIcon from "./src/measurement-tape.svg";
import MeterHighIcon from "./src/meter-high.svg";
import MeterLowIcon from "./src/meter-low.svg";
import NoImageAvailable from "./src/no-image-available.svg";
import OwnerOperatorIcon from "./src/owner-operated.svg";
import PhasingIcon from "./src/phasing.svg";
import PhoneIcon from "./src/phone.svg";
import PlanIcon from "./src/plan.svg";
import PlantIcon from "./src/plant.svg";
import PlusIcon from "./src/plus-icon.svg";
import PremiumExperienceIcon from "./src/premium-experience.svg";
import ProPromiseReviewIcon from "./src/pro-promise-review.svg";
import ProPromiseServiceIcon from "./src/pro-promise-service.svg";
import ProPromiseVerifyIcon from "./src/pro-promise-verify.svg";
import LawnInstallation from "./src/project-elements/lawn-installation-grass.svg";
import TurfInstallationIcon from "./src/project-elements/lawn-installation-turf.svg";
import LawnRemoval from "./src/project-elements/lawn-removal.svg";
import PlantingIcon from "./src/project-elements/new-plants.svg";
import TreesIcon from "./src/project-elements/new-trees-and-or-shrubs.svg";
import ProsIcon from "./src/pros.svg";
import QualityContractorIcon from "./src/quality-contractor.svg";
import ResponsiveCommunicationIcon from "./src/responsive-communication.svg";
import SuccessIcon from "./src/success-icon.svg";
import SuperProIcon from "./src/super-pro-badge.svg";
import TapIcon from "./src/tap.svg";
import TextInstructionOneIcon from "./src/text-instruction-one.svg";
import TextInstructionThreeIcon from "./src/text-instruction-three.svg";
import TextInstructionTwoIcon from "./src/text-instruction-two.svg";
import Traditional2DPlansIcon from "./src/traditional-process/2d-plans.svg";
import TraditionalConfusedIcon from "./src/traditional-process/confused.svg";
import TraditionalLockedInIcon from "./src/traditional-process/locked-in.svg";
import TraditionalTimeConsumingIcon from "./src/traditional-process/time-consuming.svg";
import ValueProIcon from "./src/value-pro.svg";
import VeteranOwnedIcon from "./src/veteran-owned.svg";
import ViewEstimateIcon from "./src/view-estimate.svg";
import WarningIcon from "./src/warning-icon.svg";
import WhiteChatIcon from "./src/white-chat-icon.svg";
import WinkIcon from "./src/wink.svg";
import YardzenApprovedIcon from "./src/yardzen-approved.svg";
import YardzenLogoFullIcon from "./src/yardzen-logo-full.svg";
import YardzenLogoMobileIcon from "./src/yardzen-logo-mobile.svg";
import YardzenContractorIcon from "./src/yardzen-process/contractor.svg";
import YardzenDesignTalentIcon from "./src/yardzen-process/design-talent.svg";
import YardzenRelaxedIcon from "./src/yardzen-process/relaxed.svg";
import YardzenRendersIcon from "./src/yardzen-process/renders.svg";
import YardzenIcon from "./src/yardzen.svg";
import YearsInBusinessIcon from "./src/years-in-business.svg";
import YzProHeaderLogoIcon from "./src/yzpro-header-logo.png";

import QuizAlmostDoneIcon from "./src/quiz-almost-done.svg";
import QuizDreamYard from "./src/quiz-dream-yard.svg";
import QuizStartIcon from "./src/quiz-start.svg";
import QuizTellUsIcon from "./src/quiz-tell-us.svg";

export * as MarketingIcons from "@yardzen/components/icons";
export * from "./src/ArrowRight";
export * from "./src/Calendar";
export * from "./src/ChatFilled";
export * from "./src/CircledCheck";
export * as DesignQuizIcons from "./src/design-quiz";
export * from "./src/Download";
export * as FaIcon from "./src/FaIcon";
export * from "./src/NewTabLink/index";
export * as OnboardingWishlistIcons from "./src/onboarding-wishlist";
export * from "./src/PaperAirplane";
export * from "./src/PartyPopper";
export * as ProjectElementsIcons from "./src/project-elements";
export * from "./src/Sweat";
export * from "./src/TooltipInfo";

export {
  AccountIcon,
  AdminReadConvosIcon,
  AffirmLogoIcon,
  AlreadyHasContractorIcon,
  AvatarIcon,
  BackyardIcon,
  BellIcon,
  BipocOwnedIcon,
  BlueprintIcon,
  BondedIcon,
  BookingFastIcon,
  BudgetIcon,
  BuildProjectIcon,
  CalendarIcon,
  CalendarMonthIcon,
  Chat2Icon,
  ChatBubble,
  ChatIcon,
  ChatIcon3,
  ChatOutlineIcon,
  Check1Icon,
  ChecklistIcon,
  CircledCheckIcon,
  ConstructorIcon,
  ConversationIcon,
  CopyIcon,
  DesignProjectsIcon,
  DiyIcon,
  EcoFriendlyIcon,
  EstimateMatchIcon,
  EstimatesIcon,
  ExteriorHomeIcon,
  FamilyOwnedIcon,
  FemaleFoundedIcon,
  FiltersIcon,
  FinishQuicklyIcon,
  FreeEstimatesIcon,
  FrontYardIcon,
  FullYardIcon,
  GoodbyeIcon,
  GuidanceIcon,
  HandShakeIcon,
  HangingLightIcon,
  HelmetIcon,
  HelmetOutlineIcon,
  HelpCenterIcon,
  HelpIcon,
  HouseAndBushes,
  LawnInstallation,
  LawnRemoval,
  LicensedIcon,
  LoadingArrows,
  LocationMarkerIcon,
  LoginIcon,
  LogoutIcon,
  MeasuementTapeIcon,
  MeterHighIcon,
  MeterLowIcon,
  NoImageAvailable,
  OwnerOperatorIcon,
  PhasingIcon,
  PhoneIcon,
  PlanIcon,
  PlantIcon,
  PlantingIcon,
  PlusIcon,
  PremiumExperienceIcon,
  ProPromiseReviewIcon,
  ProPromiseServiceIcon,
  ProPromiseVerifyIcon,
  ProsIcon,
  QualityContractorIcon,
  QuizAlmostDoneIcon,
  QuizDreamYard,
  QuizStartIcon,
  QuizTellUsIcon,
  ResponsiveCommunicationIcon,
  SuccessIcon,
  SuperProIcon,
  TapIcon,
  TextInstructionOneIcon,
  TextInstructionThreeIcon,
  TextInstructionTwoIcon,
  Traditional2DPlansIcon,
  TraditionalConfusedIcon,
  TraditionalLockedInIcon,
  TraditionalTimeConsumingIcon,
  TreesIcon,
  TurfInstallationIcon,
  ValueProIcon,
  VeteranOwnedIcon,
  ViewEstimateIcon,
  WarningIcon,
  WhiteChatIcon,
  WinkIcon,
  YardzenApprovedIcon,
  YardzenContractorIcon,
  YardzenDesignTalentIcon,
  YardzenIcon,
  YardzenLogoFullIcon,
  YardzenLogoMobileIcon,
  YardzenRelaxedIcon,
  YardzenRendersIcon,
  YearsInBusinessIcon,
  YzProHeaderLogoIcon,
};
